import { createQuery } from '../../utils';
import {
  ConnectorConfig,
  ConnectorOption,
  ConnectorStatus,
  ListConnectorConfigsParams,
  ListConnectorParams,
} from '@hum/types';

export const getConnectorConfigs = createQuery<
  ConnectorOption[],
  ListConnectorConfigsParams
>(
  ({ api, params = {} }) => {
    const { flags, ...queryParams } = params;
    return api
      .get('v1/connector_configs', { params: queryParams })
      .then((res) => res.connectorConfigs)
      .then((connectors: ConnectorConfig[]) => {
        return connectors.map((config) => ({
          config,
        }));
      });
  },
  {
    errorToast: { message: 'Failed to fetch connector configs' },
  }
);

export const getConnectors = createQuery<
  ConnectorOption[],
  ListConnectorParams
>(
  ({ api, session, params, router }) => {
    const isAdmin = session.user?.isAdmin;
    const companyId = isAdmin
      ? router.query.company_id
      : session.user?.organizationId;
    const path = `/v2/companies/${companyId}/connectors`;

    return api
      .get(path, {
        params,
      })
      .then((connections: ConnectorOption[]) =>
        connections.filter(
          (option) => option.status !== ConnectorStatus.Authenticating
        )
      );
  },
  {
    errorToast: { message: 'Failed to fetch connectors' },
  }
);

export const getCompanyConnectors = createQuery<any[], { companyId: string }>(
  ({ api, params }) => {
    return (
      api
        .get(`/v2/companies/${params.companyId}/connectors`, { params })
        .then((res) => res) || []
    );
  },
  {
    errorToast: { message: 'Failed to fetch connectors' },
  }
);

export const getAvailableConnectors = createQuery<{}>(({ api }) => {
  return api.get(`/connectors`);
});

export const getQuickBooksConnectors = createQuery<{ companyId: string }>(
  ({ api, params }) => {
    return api.get(
      `/v2/companies/${params.companyId}/has_quickbooks_connectors`
    );
  }
);
